var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { encode, instantiate } from 'media-encoder-host';
import { addRecorderAudioWorkletModule, createRecorderAudioWorkletNode } from 'recorder-audio-worklet';
import { AudioBuffer, AudioBufferSourceNode, AudioWorkletNode, MediaStreamAudioSourceNode, MinimalAudioContext, addAudioWorkletModule } from 'standardized-audio-context';
var ERROR_MESSAGE = 'Missing AudioWorklet support. Maybe this is not running in a secure context.';
// @todo This should live in a separate file.
var createPromisedAudioNodesEncoderInstanceIdAndPort = function (audioBuffer, audioContext, channelCount, mediaStream, mimeType) { return __awaiter(void 0, void 0, void 0, function () {
    var _b, encoderInstanceId, port, audioBufferSourceNode, mediaStreamAudioSourceNode, recorderAudioWorkletNode;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, instantiate(mimeType, audioContext.sampleRate)];
            case 1:
                _b = _c.sent(), encoderInstanceId = _b.encoderInstanceId, port = _b.port;
                if (AudioWorkletNode === undefined) {
                    throw new Error(ERROR_MESSAGE);
                }
                audioBufferSourceNode = audioBuffer === null ? null : new AudioBufferSourceNode(audioContext, { buffer: audioBuffer });
                mediaStreamAudioSourceNode = new MediaStreamAudioSourceNode(audioContext, { mediaStream: mediaStream });
                recorderAudioWorkletNode = createRecorderAudioWorkletNode(AudioWorkletNode, audioContext, { channelCount: channelCount });
                return [2 /*return*/, { audioBufferSourceNode: audioBufferSourceNode, encoderInstanceId: encoderInstanceId, mediaStreamAudioSourceNode: mediaStreamAudioSourceNode, port: port, recorderAudioWorkletNode: recorderAudioWorkletNode }];
        }
    });
}); };
export var createWebAudioMediaRecorderFactory = function (createBlobEvent, createInvalidModificationError, createInvalidStateError, createNotSupportedError) {
    return function (eventTarget, mediaStream, mimeType) {
        var _a;
        var sampleRate = (_a = mediaStream.getAudioTracks()[0]) === null || _a === void 0 ? void 0 : _a.getSettings().sampleRate;
        var audioContext = new MinimalAudioContext({ latencyHint: 'playback', sampleRate: sampleRate });
        /*
         * Bug #22: Safari adds a certain number of leading zeros which need to be skipped.
         *
         * Bug #21: Firefox is the only browser not supporting audio/mp4. This is totally unrelated and just used to apply the fix only for
         * Safari.
         */
        var audioBuffer = MediaRecorder.isTypeSupported('audio/mp4')
            ? new AudioBuffer({ length: 2688, sampleRate: audioContext.sampleRate })
            : null;
        var bufferedArrayBuffers = [];
        var promisedAudioWorkletModule = addRecorderAudioWorkletModule(function (url) {
            if (addAudioWorkletModule === undefined) {
                throw new Error(ERROR_MESSAGE);
            }
            return addAudioWorkletModule(audioContext, url);
        });
        var abortRecording = null;
        var intervalId = null;
        var promisedAudioNodesAndEncoderInstanceId = null;
        var promisedPartialRecording = null;
        var isAudioContextRunning = true;
        var dispatchDataAvailableEvent = function (arrayBuffers) {
            eventTarget.dispatchEvent(createBlobEvent('dataavailable', { data: new Blob(arrayBuffers, { type: mimeType }) }));
        };
        var requestNextPartialRecording = function (encoderInstanceId, timeslice) { return __awaiter(void 0, void 0, void 0, function () {
            var arrayBuffers;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, encode(encoderInstanceId, timeslice)];
                    case 1:
                        arrayBuffers = _b.sent();
                        if (promisedAudioNodesAndEncoderInstanceId === null) {
                            bufferedArrayBuffers.push.apply(bufferedArrayBuffers, __spreadArray([], __read(arrayBuffers), false));
                        }
                        else {
                            dispatchDataAvailableEvent(arrayBuffers);
                            promisedPartialRecording = requestNextPartialRecording(encoderInstanceId, timeslice);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var resume = function () {
            isAudioContextRunning = true;
            return audioContext.resume();
        };
        var stop = function () {
            if (promisedAudioNodesAndEncoderInstanceId === null) {
                return;
            }
            if (abortRecording !== null) {
                mediaStream.removeEventListener('addtrack', abortRecording);
                mediaStream.removeEventListener('removetrack', abortRecording);
            }
            if (intervalId !== null) {
                clearTimeout(intervalId);
            }
            promisedAudioNodesAndEncoderInstanceId.then(function (_b) { return __awaiter(void 0, [_b], void 0, function (_c) {
                var arrayBuffers;
                var encoderInstanceId = _c.encoderInstanceId, mediaStreamAudioSourceNode = _c.mediaStreamAudioSourceNode, recorderAudioWorkletNode = _c.recorderAudioWorkletNode;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (promisedPartialRecording !== null) {
                                promisedPartialRecording.catch(function () {
                                    /* @todo Only catch the errors caused by a duplicate call to encode. */
                                });
                                promisedPartialRecording = null;
                            }
                            return [4 /*yield*/, recorderAudioWorkletNode.stop()];
                        case 1:
                            _d.sent();
                            mediaStreamAudioSourceNode.disconnect(recorderAudioWorkletNode);
                            return [4 /*yield*/, encode(encoderInstanceId, null)];
                        case 2:
                            arrayBuffers = _d.sent();
                            if (!(promisedAudioNodesAndEncoderInstanceId === null)) return [3 /*break*/, 4];
                            return [4 /*yield*/, suspend()];
                        case 3:
                            _d.sent();
                            _d.label = 4;
                        case 4:
                            dispatchDataAvailableEvent(__spreadArray(__spreadArray([], __read(bufferedArrayBuffers), false), __read(arrayBuffers), false));
                            bufferedArrayBuffers.length = 0;
                            eventTarget.dispatchEvent(new Event('stop'));
                            return [2 /*return*/];
                    }
                });
            }); });
            promisedAudioNodesAndEncoderInstanceId = null;
        };
        var suspend = function () {
            isAudioContextRunning = false;
            return audioContext.suspend();
        };
        suspend();
        return {
            get mimeType() {
                return mimeType;
            },
            get state() {
                return promisedAudioNodesAndEncoderInstanceId === null ? 'inactive' : isAudioContextRunning ? 'recording' : 'paused';
            },
            pause: function () {
                if (promisedAudioNodesAndEncoderInstanceId === null) {
                    throw createInvalidStateError();
                }
                if (isAudioContextRunning) {
                    suspend();
                    eventTarget.dispatchEvent(new Event('pause'));
                }
            },
            resume: function () {
                if (promisedAudioNodesAndEncoderInstanceId === null) {
                    throw createInvalidStateError();
                }
                if (!isAudioContextRunning) {
                    resume();
                    eventTarget.dispatchEvent(new Event('resume'));
                }
            },
            start: function (timeslice) {
                var _this = this;
                var _a;
                if (promisedAudioNodesAndEncoderInstanceId !== null) {
                    throw createInvalidStateError();
                }
                if (mediaStream.getVideoTracks().length > 0) {
                    throw createNotSupportedError();
                }
                eventTarget.dispatchEvent(new Event('start'));
                var audioTracks = mediaStream.getAudioTracks();
                var channelCount = audioTracks.length === 0 ? 2 : ((_a = audioTracks[0].getSettings().channelCount) !== null && _a !== void 0 ? _a : 2);
                promisedAudioNodesAndEncoderInstanceId = Promise.all([
                    resume(),
                    promisedAudioWorkletModule.then(function () { return createPromisedAudioNodesEncoderInstanceIdAndPort(audioBuffer, audioContext, channelCount, mediaStream, mimeType); })
                ]).then(function (_b) { return __awaiter(_this, [_b], void 0, function (_c) {
                    var _d = __read(_c, 2), _e = _d[1], audioBufferSourceNode = _e.audioBufferSourceNode, encoderInstanceId = _e.encoderInstanceId, mediaStreamAudioSourceNode = _e.mediaStreamAudioSourceNode, port = _e.port, recorderAudioWorkletNode = _e.recorderAudioWorkletNode;
                    return __generator(this, function (_f) {
                        switch (_f.label) {
                            case 0:
                                mediaStreamAudioSourceNode.connect(recorderAudioWorkletNode);
                                if (!(audioBufferSourceNode !== null)) return [3 /*break*/, 2];
                                return [4 /*yield*/, new Promise(function (resolve) {
                                        audioBufferSourceNode.onended = resolve;
                                        audioBufferSourceNode.connect(recorderAudioWorkletNode);
                                        audioBufferSourceNode.start();
                                    })];
                            case 1:
                                _f.sent();
                                audioBufferSourceNode.disconnect(recorderAudioWorkletNode);
                                _f.label = 2;
                            case 2: return [4 /*yield*/, recorderAudioWorkletNode.record(port)];
                            case 3:
                                _f.sent();
                                if (timeslice !== undefined) {
                                    promisedPartialRecording = requestNextPartialRecording(encoderInstanceId, timeslice);
                                }
                                return [2 /*return*/, { encoderInstanceId: encoderInstanceId, mediaStreamAudioSourceNode: mediaStreamAudioSourceNode, recorderAudioWorkletNode: recorderAudioWorkletNode }];
                        }
                    });
                }); });
                var tracks = mediaStream.getTracks();
                abortRecording = function () {
                    stop();
                    eventTarget.dispatchEvent(new ErrorEvent('error', { error: createInvalidModificationError() }));
                };
                mediaStream.addEventListener('addtrack', abortRecording);
                mediaStream.addEventListener('removetrack', abortRecording);
                intervalId = setInterval(function () {
                    var currentTracks = mediaStream.getTracks();
                    if ((currentTracks.length !== tracks.length || currentTracks.some(function (track, index) { return track !== tracks[index]; })) &&
                        abortRecording !== null) {
                        abortRecording();
                    }
                }, 1000);
            },
            stop: stop
        };
    };
};
//# sourceMappingURL=web-audio-media-recorder.js.map
